import { isEmpty } from 'lodash';
import { setResult } from './resultActions';
import { makeApiGetRequest, makeApiPatchRequest, makeApiPostRequest, getCSRFToken } from './apiActions';
import SpellingServiceClient from '../clients/SpellingServiceClient';
import selectors from '../../rootSelectors';
import { isMClassUser } from '../keycloak/keycloakUtils';

export const createResult = (measure, formId, language) => (dispatch, getStore) => {
    const state = getStore();
    const instId = selectors.getInstId(state, measure);
    const postBody = {
        grade_level: selectors.getGrade(state),
        inst_uid: instId,
        period: selectors.getToy(state),
        school_year: selectors.getSchoolYear(state),
        student_uid: selectors.getUserId(state),
        assessment_mode: 'online',
        assessment: SpellingServiceClient.NAME,
        student_temporal_id: selectors.getStudentTemporalId(state, instId) || undefined,  // unset if not available
        form_id: formId,
        measure,
        language,
    };
    const endpoint = SpellingServiceClient.constructCreateResultEndpoint();
    if (isMClassUser()) {
        postBody.csrf_token = getCSRFToken();
    }
    return dispatch(makeApiPostRequest(endpoint, postBody))
        .then((resultJson) => {
            dispatch(setResult(resultJson));
            return resultJson.result_id;
        });
};

export const saveResultResponse = (
    resultId,
    itemId,
    itemIndex,
    formId,
    selectedResponse,
    measure,
    duration,
    markComplete,
) => dispatch => {
    const operation = markComplete
        ? SpellingServiceClient.RESULT_OPERATION.ADD_RESPONSE_WITH_COMPLETE
        : SpellingServiceClient.RESULT_OPERATION.ADD_RESPONSE;
    const patchData = {
        operation,
        measure,
        data: {
            item_id: itemId,
            item_idx: itemIndex,
            form_id: formId,
            time_duration: duration,
            response: selectedResponse,
        },
    };
    const endpoint = SpellingServiceClient.constructSaveResultEndpoint(resultId);

    return dispatch(makeApiPatchRequest(endpoint, patchData));
};

export const saveMeasureResponse = (
    measure,
    itemId,
    itemIndex,
    formId,
    selectedResponse,
    duration,
    markComplete = false,
    language,
) => (dispatch, getStore) => {
    const state = getStore();
    const result = selectors.findResultFor(state, {
        measure,
        formId,
        isComplete: false,
    });
    let createResultPromise;

    if (result !== undefined) {
        createResultPromise = Promise.resolve(result.id);
    } else {
        createResultPromise = dispatch(createResult(measure, formId, language));
    }

    return createResultPromise.then((resultId) => dispatch(
        saveResultResponse(resultId,
            itemId,
            itemIndex,
            formId,
            selectedResponse,
            measure,
            duration,
            markComplete,
        )));
};

export const getStudentResults = () => (dispatch, getStore) => {
    const state = getStore();
    const studentId = selectors.getUserId(state);
    const grade = selectors.getGrade(state);
    const period = selectors.getToy(state);
    const schoolYear = selectors.getSchoolYear(state);
    const language = selectors.getPlaylistActiveLanguages(state).join(',');
    const config = {
        studentId,
        grade,
        period,
        schoolYear,
        language,
    };
    const endpoint = SpellingServiceClient.constructResultListEndpoint(config);

    return dispatch(makeApiGetRequest(endpoint))
        .then((data) => {
            const resultsData = isEmpty(data) ? [] : data;
            resultsData.forEach((resultData) => {
                dispatch(setResult(resultData));
            });
        });
};
